export default "/images/2f2306c6f9ad66521e6a1c08cd3a497e.avif";